import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { ErrorMessages } from 'src/common/constants';
import { PasswordRequirements } from 'src/SharedCustomHooks/UsePasswordRequirements/usePasswordRequirements';
import './password-requirements-list.scss';

interface RequirementDefinition {
  key: keyof PasswordRequirements;
  label: string;
}

const REQUIREMENT_DEFINITIONS: RequirementDefinition[] = [
  { key: 'hasMinLength', label: ErrorMessages.passwordRequirement1 },
  { key: 'hasUppercase', label: ErrorMessages.passwordRequirement2 },
  { key: 'hasLowercase', label: ErrorMessages.passwordRequirement3 },
  { key: 'hasNumber', label: ErrorMessages.passwordRequirement4 },
  { key: 'hasSpecialCharacter', label: ErrorMessages.passwordRequirement5 },
];

interface PasswordRequirementRow {
  key: keyof PasswordRequirements;
  label: string;
  rowClassName: string;
  glyph: 'check' | 'times';
}

interface PasswordRequirementsListProps {
  requirements: PasswordRequirements;
}

const PasswordRequirementsList = ({
  requirements,
}: PasswordRequirementsListProps) => {
  const rows: PasswordRequirementRow[] = REQUIREMENT_DEFINITIONS.map(
    ({ key, label }: RequirementDefinition) => {
      const isMet: boolean = requirements[key];

      return {
        key,
        label,
        rowClassName: isMet ? 'prl-row prl-row-met' : 'prl-row prl-row-unmet',
        glyph: isMet ? 'check' : 'times',
      };
    }
  );

  return (
    <ul className="password-requirements-list">
      {rows.map(({ key, label, rowClassName, glyph }: PasswordRequirementRow) => (
        <li key={key} className={rowClassName}>
          <span className="prl-icon">
            <FontAwesomeIcon glyph={glyph} weight="solid" size="small" />
          </span>
          <span className="prl-label">{label}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirementsList;
